import { DeviceBasic } from 'src/app/models/device-models/device-basic-model/device-basic.model';

export class DepartmentBasic {

    private active: boolean;
    private centerInternalId: string;
    private centerName: string;
    private deleted: boolean;
    private devicesBound: Array<DeviceBasic>;
    private hasPhysicalAssistance: boolean;
    private hasVideoconference: boolean;
    private onlyVoice: boolean;
    private internalId: string;
    private location: string;
    private sectionImage: string;
    private sectionName: string;
    private askName: boolean;

    constructor(active?: boolean, centerName?: string, centerInternalId?: string, deleted?: boolean, devicesBound?: Array<DeviceBasic>, hasPhysicalAssistance?: boolean, hasVideoconference?: boolean, onlyVoice?: boolean, internalId?: string, location?: string, sectionImage?: string, sectionName?: string, askName?: boolean) {
        this.active = active;
        this.centerName = centerName;
        this.centerInternalId = centerInternalId;
        this.deleted = deleted;
        this.devicesBound = devicesBound;
        this.hasPhysicalAssistance = hasPhysicalAssistance;
        this.hasVideoconference = hasVideoconference;
        this.onlyVoice = onlyVoice;
        this.internalId = internalId;
        this.location = location;
        this.sectionImage = sectionImage;
        this.sectionName = sectionName;
        this.askName = askName;
    }

    public get Active() {
        return this.active;
    }

    public get CenterInternalId() {
        return this.centerInternalId;
    }

    public get CenterName() {
        return this.centerName;
    }

    public get Deleted() {
        return this.deleted;
    }

    public get DevicesBound() {
        return this.devicesBound;
    }

    public get HasPhysicalAssistance() {
        return this.hasPhysicalAssistance;
    }

    public get HasVideoconference() {
        return this.hasVideoconference;
    }

    public get OnlyVoice() {
        return this.onlyVoice;
    }

    public get InternalId() {
        return this.internalId;
    }

    public get Location() {
        return this.location;
    }

    public get SectionImage() {
        return this.sectionImage;
    }

    public get SectionName() {
        return this.sectionName;
    }

    public get AskName() {
        return this.askName;
    }

    public set Active(active) {
        this.active = active;
    }

    public set CenterInternalId(centerInternalId) {
        this.centerInternalId = centerInternalId;
    }

    public set CenterName(centerName) {
        this.centerName = centerName;
    }

    public set Deleted(deleted) {
        this.deleted = deleted;
    }

    public set DevicesBound(devicesBound) {
        this.devicesBound = devicesBound;
    }

    public set HasPhysicalAssistance(hasPhysicalAssistance) {
        this.hasPhysicalAssistance = hasPhysicalAssistance;
    }

    public set HasVideoconference(hasVideoconference) {
        this.hasVideoconference = hasVideoconference;
    }

    public set OnlyVoice(onlyVoice) {
        this.onlyVoice = onlyVoice;
    }

    public set InternalId(internalId) {
        this.internalId = internalId;
    }

    public set Location(location) {
        this.location = location;
    }

    public set SectionImage(sectionImage) {
        this.sectionImage = sectionImage;
    }

    public set SectionName(sectionName) {
        this.sectionName = sectionName;
    }

    public set AskName(askName) {
        this.askName = askName;
    }
}
